import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=5401cb3b&scoped=true"
import script from "./noticeItem.vue?vue&type=script&lang=js"
export * from "./noticeItem.vue?vue&type=script&lang=js"
import style0 from "./noticeItem.vue?vue&type=style&index=0&id=5401cb3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401cb3b",
  null
  
)

export default component.exports